export const categories = () => {
  return [
    {
      icon      : 'fas fa-globe',
      name      : 'Todos',
      nameEng   : 'All',
      principal : true,
      category  : 'all'
    },
    {
      icon      : 'fa fa-user',
      name      : 'Blogs',
      nameEng   : 'Blogs',
      principal : true,
      category  : 'blogs'
    },
    {
      icon      : 'fab fa-wordpress',
      name      : 'Portales / CMS',
      nameEng   : 'Portals / CMS',
      principal : true,
      category  : 'cms'
    },
    {
      icon      : 'fas fa-shopping-cart',
      name      : 'Comercio electrónico',
      nameEng   : 'Ecommerce',
      principal : true,
      category  : 'ecommerce'
    },
    {
      icon      : 'fas fa-chart-bar',
      name      : 'ERP',
      nameEng   : 'ERP',
      principal : true,
      category  : 'erp'
    },
    {
      icon      : 'fas fa-file',
      name      : 'Gestión de ficheros',
      nameEng   : 'Management Files',
      principal : true,
      category  : 'management_files'
    },
    {
      icon      : 'fas fa-graduation-cap',
      name      : 'Educacional',
      nameEng   : 'Educational',
      principal : true,
      category  : 'educational'
    },
    {
      icon      : 'fa fa-comments',
      name      : 'Micro Blogs',
      nameEng   : 'Micro Blogs',
      principal : false,
      category  : 'micro_blogs'
    },
    {
      icon      : 'fa fa-users',
      name      : 'Foros',
      nameEng   : 'Forums',
      principal : false,
      category  : 'foros'
    },
    {
      icon      : 'far fa-images',
      name      : 'Galerías de imágenes',
      nameEng   : 'Image galleries',
      principal : false,
      category  : 'images_gallery'
    },
    {
      icon      : 'fas fa-globe-americas',
      name      : 'Wikis',
      nameEng   : 'Wikis',
      principal : false,
      category  : 'wikis'
    },
    {
      icon      : 'far fa-comments',
      name      : 'Social Networking',
      nameEng   : 'Social Networking',
      principal : false,
      category  : 'social_networking'
    },
    {
      icon      : 'fas fa-bullhorn',
      name      : 'Anuncios',
      nameEng   : 'Announcements',
      principal : false,
      category  : 'announcements'
    },
    {
      icon      : 'fas fa-calendar-alt',
      name      : 'Calendarios',
      nameEng   : 'Calendars',
      principal : false,
      category  : 'calendars'
    },
    {
      icon      : 'fas fa-gamepad',
      name      : 'Juegos',
      nameEng   : 'Games',
      principal : false,
      category  : 'games'
    },
    {
      icon      : 'fas fa-envelope',
      name      : 'Correo',
      nameEng   : 'Email',
      principal : false,
      category  : 'email'
    },
    {
      icon      : 'fas fa-chart-pie',
      name      : 'Votaciones y encuestas',
      nameEng   : 'Votes and surveys',
      principal : false,
      category  : 'voting'
    },
    {
      icon      : 'fas fa-edit',
      name      : 'Gestor de proyectos',
      nameEng   : 'Manager Proyects',
      principal : false,
      category  : 'manager_proyects'
    },
    {
      icon      : 'fas fa-book-reader',
      name      : 'Libros de visitas',
      nameEng   : 'Guest books',
      principal : false,
      category  : 'books_visits'
    },
    {
      icon      : 'fas fa-question-circle',
      name      : 'Ayuda al cliente',
      nameEng   : 'Help the client',
      principal : false,
      category  : 'help_customer'
    },
    {
      icon      : 'fas fa-cogs',
      name      : 'Frameworks',
      nameEng   : 'Frameworks',
      principal : false,
      category  : 'frameworks'
    },
    {
      icon      : 'fas fa-database',
      name      : 'DB Tools',
      nameEng   : 'DB Tools',
      principal : false,
      category  : 'bd_tools'
    },
    {
      icon      : 'fas fa-music',
      name      : 'Música',
      nameEng   : 'Music',
      principal : false,
      category  : 'music'
    },
    {
      icon      : 'fas fa-video',
      name      : 'Video',
      nameEng   : 'Video',
      principal : false,
      category  : 'videos'
    },
    {
      icon      : 'fas fa-rss',
      name      : 'RSS',
      nameEng   : 'RSS',
      principal : false,
      category  : 'rss'
    },
    {
      icon      : 'fas fa-folder-open',
      name      : 'Otros',
      nameEng   : 'Others',
      principal : false,
      category  : 'others'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Data/menu_category.js